import React, { useEffect, useState } from 'react';

import { Link, useLocation } from 'react-router-dom';
import Header from './Header';

import Knoppie from './Knoppie';
import Vraag from './Vraag';
import Antwoord from './Antwoord';

import Text from './Text';
import clicksound from '../Assets/click.wav'
import korreksound from '../Assets/beep.wav'
import wrongsound from '../Assets/triple_beep.wav'

import'../Game.css'

var vrae = []
const Game = ()=>{
    
    
    const location = useLocation()
    const  tafelnrs  = location.state.tafelnrs
    const aantalvrae = location.state.aantalvrae
    const colorone = location.state.colorone
    const colortwo = location.state.colortwo
    const finalevrae = JSON.parse(localStorage.getItem("vrae"))

    console.log(tafelnrs)
    console.log(aantalvrae)
    console.log(colorone)
    
    const [random,setRandom] = useState(Math.floor(Math.random()*(12-1+1)+1))
    const [tafel, setTafel] = useState(tafelnrs[0])
    const knoppies =  [1,2,3,4,5,6,7,8,9,"Terug",0,"Antwoord"]
    const [antwoord, setAntwoord] = useState("")
    const [counter,setcounter] = useState(1)
    const [korrekCount,setkorrekCount] = useState(0)
    const [laasteantwoord,setlaasteantwoord] = useState(false)
    const [korrek,setkorrek] = useState(true)
    const [time,settime] = useState(0)
    

    const handleprint = ()=>{
        
        window.print(finalevrae)
      }

      
    useEffect(()=>{

        if (counter === 1){
            vrae =[]
        }

        if (counter===aantalvrae+1){
            setlaasteantwoord(true)
            setcounter(1)
            localStorage.setItem("finaltime",time)
            
        }
        

        setTimeout(()=>settime(time + 1),1000);

    },[counter,aantalvrae,korrek,time])

    const randomInt = () => {
        var max = 12
        var min = 1
        var newnumber = Math.floor(Math.random()*(max-min+1)+min)
        setRandom(newnumber)
      
        var tmax = tafelnrs.length
        var tmin = 1
        var nommer = Math.floor(Math.random()*(tmax-tmin+1)+tmin)
        
        setTafel(tafelnrs[nommer-1])


    }
    const checkAntwoord = ()=>{
        var korrekteantwoord = Number(random * tafel)
        
        console.log(korrekteantwoord,antwoord)
        if (Number(antwoord) === korrekteantwoord){
            setkorrekCount(korrekCount+1)
            new Audio(korreksound).play()
            return true
        }else{
            new Audio(wrongsound).play()
            return false

        }
        

    }

    const addnumber = async (e)=>{
        new Audio(clicksound).play()
        if (e.target.innerText.trim()!=="Antwoord" || e.target.innerHTML.trim()!=="Terug"){
            console.log(e.target)
            console.log(e.target.innerHTML)
            console.log(e.target.innerText)
            setAntwoord(antwoord.concat(e.target.innerText.trim()))
        }

        if (e.target.innerText.trim() === "Terug"){
            setAntwoord(antwoord.slice(0,-1))
        }
        if (e.target.innerText.trim() === "Antwoord"){
                setkorrek("")
                setkorrek(checkAntwoord())
           
                vrae.push({ id:Math.random(),vraag:random +" x " +tafel,antwoord:antwoord, korrek:checkAntwoord(),reg:Number(random * tafel)})
               
                localStorage.setItem("vrae",JSON.stringify(vrae))
                localStorage.setItem("vraag",tafel + " x "+ random)
                localStorage.setItem("antwoord",antwoord)
                
                setAntwoord("")
                
                setcounter(counter+1)
                randomInt()


        }

    }

    
    console.log(tafel,random)

    // const vraag = tafelnrs[1-Math.random()] + " x "+

    return(

    <>
    <Header  colorone={colorone} colortwo={colortwo} />


    <div class="TafelsListInfo">
        <div class="List">Jy het die volgende tafels gekies om te oefen:</div>
        <div class="List">
        {tafelnrs.map(nommer=>(
            <div key={nommer} >

                <Knoppie nommer={nommer} colorone={colorone} colortwo={colortwo}list={true}>
                </Knoppie>
                
            </div>
    

        ))}
        </div>
    </div>

    

            
        
           
            
         {laasteantwoord?(
         
         <div >
            
            
            <div class="List"> Toets is verby. Jy het {korrekCount} vrae uit {aantalvrae} korrek beantwoord in {localStorage.getItem("finaltime")} sekondes.</div>
            <div>
                {finalevrae.map(vraag=>(
                    <div key={vraag.id}>

                    <Antwoord vraag={vraag.vraag} antwoord={vraag.antwoord} korrek={vraag.korrek} reg={vraag.reg} colorone={colorone} colortwo={colortwo}></Antwoord>

                    </div>
                ))}
      
            </div>
            
            
            <div>
        
        <button onClick={handleprint}>Print</button>

        <Link to='/'>

          <Knoppie
           nommer = {"Speel weer?"} 
           colorone={colorone}
           colortwo={colortwo}
          />

        </Link>

        </div>
         </div>):(
        <div> 
            <div>

           <Text text={time}></Text>

            </div>

            <div key={random}>
                <Vraag nommer1={random} nommer2={tafel}>
                </Vraag> 
            </div> 
         
            <div className='AntwoordBoksie'>Antwoord = {antwoord}</div>
        
        <div className='keypad'>
            {knoppies.map(knoppie=>(

                                
                <div key={knoppie} className='keypad_knoppie'>
                    <Knoppie nommer={knoppie} callback={addnumber} colorone={colorone} colortwo={colortwo}></Knoppie>

                </div>
            ))}

        </div>
        
         </div>
         
         
         )}   
            

        
    
    </>

    )
}

export default Game;